<template>


    <div class="content-wrapper  " style="background-color:#eee ; height: 100%">




        <CRow class="justify-content-md-center">
            <CCol sm="6">
                <CCard>
                    <form v-on:submit.prevent="saveForm()">

                        <CCardHeader>
                            <strong>اطلاعات تماس جدید </strong>
                            <!--                        <div class="card-header-actions">-->
                            <!--                            <a-->
                            <!--                                    href="#"-->
                            <!--                                    class="card-header-action"-->
                            <!--                                    rel="noreferrer noopener"-->
                            <!--                                    target="_blank"-->
                            <!--                            >-->
                            <!--                                <small class="text-muted">خروجی اکسل</small>-->
                            <!--                            </a>-->
                            <!--                        </div>-->
                        </CCardHeader>
                        <CCardBody>


                            <CRow>
                                <CCol sm="6">
                                    <CInput
                                            v-model="item.first_name"
                                            label="نام"
                                            placeholder=""
                                    />
                                </CCol>
                                <CCol sm="6">
                                    <CInput
                                            v-model="item.last_name"
                                            label=" نام خانوادگی"
                                            placeholder=""
                                    />
                                </CCol>

                            </CRow>


                            <CRow>
                                <CCol sm="6">
                                    <CInput
                                            v-model="item.mobile"
                                            label="موبایل (اصلی)"
                                            type="number"
                                            placeholder=""
                                            valid-feedback="فرمت شماره تلفن درست است"
                                            invalid-feedback="فرمت شماره تلفن صحیح نمی باشد"
                                            :is-valid="validatorMobile"
                                    />
                                </CCol>

                                <CCol sm="6">
                                    <CInput
                                            v-model.number="item.tell"
                                            label="تلفن/فکس (اصلی)"
                                            placeholder=""
                                            valid-feedback="فرمت شماره تلفن درست است"
                                            invalid-feedback="فرمت شماره تلفن صحیح نمی باشد"
                                            :is-valid="validatorTell"
                                    />
                                </CCol>
                            </CRow>


                            <CRow>
                                <CCol sm="6">
                                    <CInput
                                            v-model="item.email"
                                            label="ایمیل"
                                            type="email"
                                            placeholder=""
                                    />
                                </CCol>
                                <CCol sm="6">

                                    <label class="control-label">شهر</label>
                                    <v-select
                                            v-model="item.city"
                                            :options="cities"></v-select>

                                    <!--                                <v-select :options="cities" label="title" >-->
                                    <!--                                    <template #search="{tags}">-->
                                    <!--                                        <input-->
                                    <!--                                                class="vs__search"-->
                                    <!--                                                :required="!selected"-->
                                    <!--                                                v-bind="tags"-->
                                    <!--                                        />-->
                                    <!--                                    </template>-->
                                    <!--                                </v-select>-->








                                </CCol>

                            </CRow>
                            <CRow>
                                <CCol sm="12">
                                    <CInput
                                            v-model="item.address"
                                            label="آدرس"
                                            placeholder=""
                                    />
                                </CCol>

                            </CRow>




                            <CRow>
                                <CCol sm="6"
                                >

                                    <label class="control-label">نوع  </label>
                                    <select class="form-control" v-model="item.type ">
                                        <option value="1">سرنخ </option>
                                        <option value="2">فرصت </option>
                                        <option value="3" style="font-weight: bold">{{$client}} </option>
                                        <option value="4" style="font-weight: bold">تامین کننده </option>
                                        <option value="5">همکار/پیمانکار </option>
                                        <option value="0">نامشخص </option>

                                    </select>
                                </CCol>



                                <CCol sm="6" class="pt-4">
                                    <b-btn @click="showLegalItems = !showLegalItems">
                                        سایر آیتم ها
                                    </b-btn>
                                    <b-btn @click="showTrackingItems = !showTrackingItems">
                                        آیتم های پیگیری
                                    </b-btn>
                                </CCol>

                            </CRow>











                            <CRow v-if="showLegalItems" style="background-color: #E8E9EC" class="my-4 py-2">

                                <!--                            post_code: '', other_info:'',-->


                                <CCol sm="6"
                                >
                                    <label class="control-label">حقیقی / حقوقی </label>
                                    <select class="form-control" v-model="item.legal">
                                        <option value="1">حقیقی </option>
                                        <option value="2">حقوقی </option>


                                    </select>
                                </CCol>
                                <CCol sm="6">
                                    <CInput
                                            v-model="item.company"
                                            label="شرکت"
                                            placeholder=""
                                    />
                                </CCol>

                                <CCol sm="6">
                                    <CInput
                                            v-model="item.brand"
                                            label="برند"
                                            placeholder=""
                                    />
                                </CCol>
                                <CCol sm="6">
                                    <CInput
                                            v-model="item.web"
                                            label="سایت / پیج"
                                            placeholder=""
                                    />
                                </CCol>


                                <CCol sm="6">
                                    <CInput
                                            v-model="item.national_code"
                                            label="کد‌ملی / شناسه‌ملی"
                                            placeholder=""
                                    />
                                </CCol>
                                <CCol sm="6">
                                    <CInput
                                            v-model="item.economic_code"
                                            label="کد اقتصادی"
                                            placeholder=""
                                    />
                                </CCol>

                            </CRow >







                            <CRow v-if="showTrackingItems">



                                <CCol sm="6">

                                    <CInput
                                            v-model="item.source"
                                            label="منبع"
                                            placeholder="تلفن، سایت، اینستاگرام و ..."
                                    />
                                </CCol>

                                <CCol sm="6">

                                    <label class="control-label">وضعیت پیگیری </label>
                                    <select class="form-control" v-model="item.status ">
                                        <option value="0">نامشخص </option>
                                        <option value="1">نیاز به بررسی از سمت {{$client}} </option>
                                        <option value="2">تعیین قرار تلفنی بعدی </option>
                                        <option value="3">تعیین قرار حضوری بعدی </option>
                                        <option value="4">پیگیری از طریق پیام رسان </option>
                                        <option value="5">ارسال پروپوزال </option>
                                        <option value="6">ارسال پیش فاکتور </option>
                                        <option value="7">عدم همکاری </option>
                                    </select>
                                </CCol>

                                <CCol sm="12" v-if="disableAppointmentTime()">
                                    <label class="control-label">تاریخ قرار/تماس بعد </label>
                                    <custom-time-picker  v-model="item.next_appointment" :disabled="!disableAppointmentTime()"
                                                         type="datetime" :clearable="true" placeholder="تاریخ را انتخاب کنید " min="" max="">
                                    </custom-time-picker>


                                </CCol>


                                <CCol sm="6">
                                    <CInput
                                            v-model="item.code"
                                            label="کد رابط مالی"
                                            placeholder="کد حسابداری"
                                    />

                                </CCol>
                                <CCol sm="6">
                                    <CTextarea
                                            v-model="item.appointment_note"
                                            label="یادداشت"
                                            placeholder=""
                                            row="1"
                                    ></CTextarea>

                                </CCol>

                            </CRow>




                        </CCardBody>


                        <CCardFooter>
                            <CButton type="submit" size="sm" color="success"><CIcon name="cil-check-circle"/> ثبت</CButton>
                            <!--                        <CButton type="reset" size="sm" color="danger"><CIcon name="cil-ban"/> Reset</CButton>-->
                        </CCardFooter>
                    </form>


                </CCard>
            </CCol>

        </CRow>






    </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
    const auth = {
        headers: {
            Authorization: 'bearer ' + localStorage.getItem('token')
        }
    };

 import Multiselect from 'vue-multiselect'
    export default {
           components: {
            Multiselect
        },
        mounted() {
            axios
                .get('/api/contact/tagslist', this.auth)
                .then(response => {

                    for (const key in response.data) {
                        if (response.data.hasOwnProperty(key)) {
                            const element = response.data[key];
                            // console.log(element)

                            this.options.push({
                                title: element.title,
                                id: element.id
                            })
                            // this.details[0].
                        }
                    }
                    this.loader = false
                    // console.log(this.options);

                })
                .catch(error => {
                    console.log(error);
                    this.errored = true
                })
                .finally(() => this.loading = false)
        
            let app = this;
            let id = app.$route.params.id;
            app.itemId = id;
            app.loader = true
            axios.get('/api/contacts/' + id, app.auth)
                .then(function (resp) {
                    app.item = resp.data.data;
                    console.log(app.item)
                    app.loader = false
                })
                .catch(function () {
                    alert(22);
                    //                    console.log('a: ' + auth)
                });
            axios
                .get('/api/contact/groups', app.auth)
                .then(response => {
                    app.groups = response.data.data;
                    // console.log(this.groups, "44");

                })
                .catch(error => {
                    console.log(error);
                    app.errored = true
                })
                .finally(() => app.loading = false)
        },
        data: function () {
            return {
                auth: {
                    headers: {
                        Authorization: 'bearer ' + localStorage.getItem('token')
                    }
                },
                tags: [],
                options: [],
                itemId: null,
                groups: [],
                item: {
                    user_id: '1',
                    code: '',
                    // personal_code: '',
                    image: '',
                    first_name: '',
                    last_name: '',
                    mobile: '',
                    email: '',
                    tell: '',
                    country: '',
                    city: '',
                    address: '',
                    location: '',
                    post_code: '',
                    national_code: '',
                    type: '',
                    state: '',
                    status:'',
                    forecast:'',
                    probability:'',
                    source:'',
                    next_appointment:'',
                    appointment_note:'',
                    tags:[],


                    company:'',
                    brand:'',
                    legal:'',
                    economic_code:'',
                    accounting_code:'',
                    web:'',
                    credit:'',
                    other_info:'',

                },
                errors: [],
                loader: false,

                cities: ['تهران','کرج','اصفهان','مشهد','اهواز','کاشان'],
                // options: [],

                object: Object,

                observer: null,
                limit: 10,
                search: '',

                showTrackingItems: false,
                showLegalItems: false,






            }
        },
        methods: {



            validatorMobile (val) {
                // return val ? val.length >= 11 : null
                // if (val.length !== 11 && val.length > 0)
                if (val){
                    if (val.length !== 11 && val.length > 0)
                        return false
                    else if (val.length === 11)
                        return true
                    else
                        return null
                }

            },
            validatorTell (val) {
                // return val ? val.length >= 11 : null
                // if (val.length !== 11 && val.length > 0)
                if (val){
                    if (val.length >= 8 && val.length > 0)
                        return false
                    else if (val.length >= 8)
                        return true
                    else
                        return null
                }

            },


            disableAppointmentTime (val) {
                // return val ? val.length >= 11 : null
                // if (val.length !== 11 && val.length > 0)
                if (this.item.status == 2 || this.item.status == 3)
                    return true
                else
                    return false

            },


            customLabel(option) {
                //   console.log(option.title)

                //   this.item.tags.push(option)
                return `${option.title}`

            },

            pluck(array, key) {
                return array.map(function (obj) {
                    return obj[key];
                });
            },
            saveForm() {
                var app = this;
                var newItem = app.item;
                app.loader = true
                if(newItem.tags.length !==0){
                    newItem.tags=this.pluck(newItem.tags,"id")
                }
                 
                 console.log(newItem)
                axios.patch('/api/contacts/' + app.itemId, newItem, app.auth)
                    .then(function (resp) {
                        app.$snotify.success(12312312);
                        app.$router.replace('/contact/list');
                        app.loader = false
                    })
                    .catch(function (e) {
                        app.errors.push(e.response.data.messages_fa);
                        console.log(e.response.data);
                        for (let value of e.response.data.messages_fa) {
                            app.$snotify.warning(value, {
                                timeout: 7000,
                                closeOnClick: true,
                                pauseOnHover: true
                            });
                        }
                    });
            }
        }
    }

</script>
<style>
    .multiselect{
    text-align: right !important;
}
.multiselect__select{
    left: 1px !important;
        right: auto !important;
}
.multiselect__tags{
    padding: 8px 0 0 0 !important;
}
</style>